import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=753f7c70&scoped=true&"
import script from "./cards.vue?vue&type=script&lang=ts&"
export * from "./cards.vue?vue&type=script&lang=ts&"
import style0 from "./cards.vue?vue&type=style&index=0&id=753f7c70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753f7c70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
